module.exports = __webpack_public_path__ + "img/ba701ff37fadc2812f920f114a7e58df.svg";